/**
 * Wishlist BIS (Back-in-Stock) Integration
 *
 * Replaces Swishlist's "Rupture de Stock" ATC button with a "Prévenez-moi"
 * button. On click, opens a custom BIS modal that submits directly to
 * Klaviyo's client-side API — bypassing Klaviyo's onsite modal which cannot
 * be triggered programmatically for arbitrary products.
 *
 * Styling matches the Klaviyo modal config in klaviyo-script.liquid.
 */
(function () {
  var strings = window.bisStrings || {};
  var SOLD_OUT_TEXT = strings.soldOutText || 'Rupture de Stock';
  var BIS_LABEL = strings.button || 'Pr\u00e9venez-moi de son retour';
  var KLAVIYO_COMPANY_ID = 'TUUprJ';

  // ── Modal ────────────────────────────────────────────────────────────────

  var MODAL_ID = 'wishlist-bis-modal';

  function getOrCreateModalContainer() {
    var el = document.getElementById(MODAL_ID);
    if (el) return el;
    el = document.createElement('div');
    el.id = MODAL_ID;
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-labelledby', 'wishlist-bis-title');
    el.style.cssText = [
      'display:none',
      'position:fixed',
      'inset:0',
      'z-index:99999',
      'align-items:center',
      'justify-content:center',
      'background-color: #0000001f',
      'backdrop-filter: blur(1px)'
    ].join(';');
    document.body.appendChild(el);
    return el;
  }

  function openModal(variantId, productName) {
    var modal = getOrCreateModalContainer();
    modal.innerHTML = [
      '<div style="',
        'position:fixed;inset:0;background:rgba(0,0,0,.4);',
      '" data-bis-backdrop></div>',
      '<div style="',
        'position:relative;',
        'background:#f6f4f0;',
        'color:#5F4F46;',
        'padding:2rem;',
        'max-width:420px;',
        'width:calc(100% - 2rem);',
        'font-family:Helvetica,Arial,sans-serif;',
        'z-index:1;',
      '">',
        '<button data-bis-close style="',
          'position:absolute;top:.8rem;right:.8rem;',
          'background:none;border:none;cursor:pointer;',
          'color:#5F4F46;font-size:1.4rem;line-height:1;',
        '" aria-label="' + escapeHtml(strings.closeLabel || 'Fermer') + '">&times;</button>',

        '<h2 id="wishlist-bis-title" style="',
          'margin:0 0 .5rem;font-weight:600;',
        '">' + escapeHtml(productName) + '</h2>',

        '<p style="margin:0 0 1.2rem;font-size:1.4rem;">',
          escapeHtml(strings.bodyContent || 'Inscrivez-vous pour \u00eatre inform\u00e9(e) lorsque cette pi\u00e8ce sera de nouveau disponible.'),
        '</p>',

        '<form data-bis-form novalidate>',
          '<input type="email" name="email" placeholder="Email" required style="',
            'display:block;width:100%;box-sizing:border-box;',
            'padding:1rem .8rem;border:1px solid #5F4F46;',
            'background:transparent;color:#5F4F46;',
            'margin-bottom:.8rem;outline:none;',
          '">',
          '<button type="submit" style="',
            'display:block;width:100%;',
            'padding:1rem;',
            'background:#5F4F46;color:#fff;',
            'border:none;cursor:pointer;',
            'font-weight:400;',
            'letter-spacing:.04em;',
          '">' + escapeHtml(strings.modalButton || 'Pr\u00e9venez-moi') + '</button>',
        '</form>',

        '<p data-bis-msg style="',
          'display:none;margin:.8rem 0 0;',
        '"></p>',
      '</div>',
    ].join('');

    modal.style.display = 'flex';

    // Close handlers
    modal.querySelector('[data-bis-backdrop]').addEventListener('click', closeModal);
    modal.querySelector('[data-bis-close]').addEventListener('click', closeModal);

    // Submit
    modal.querySelector('[data-bis-form]').addEventListener('submit', function (e) {
      e.preventDefault();
      var email = this.elements.email.value.trim();
      if (!email) return;
      submitBIS(variantId, email, this, modal.querySelector('[data-bis-msg]'));
    });
  }

  function closeModal() {
    var modal = document.getElementById(MODAL_ID);
    if (modal) modal.style.display = 'none';
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // ── Klaviyo client API ───────────────────────────────────────────────────

  function submitBIS(variantId, email, form, msgEl) {
    var submitBtn = form.querySelector('[type=submit]');
    submitBtn.disabled = true;
    submitBtn.textContent = '\u2026';

    fetch(
      'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + KLAVIYO_COMPANY_ID,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          revision: '2023-09-15',
        },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: {
                data: {
                  type: 'profile',
                  attributes: { email: email },
                },
              },
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: '$shopify:::$default:::' + variantId,
                },
              },
            },
          },
        }),
      }
    )
      .then(function (res) {
        if (res.ok || res.status === 202) {
          form.style.display = 'none';
          showMsg(msgEl, strings.successLabel || 'Merci. Votre demande a bien \u00e9t\u00e9 enregistr\u00e9e.', false);
        } else {
          return res.json().then(function (body) {
            throw new Error((body.errors && body.errors[0] && body.errors[0].detail) || res.status);
          });
        }
      })
      .catch(function (err) {
        submitBtn.disabled = false;
        submitBtn.textContent = strings.modalButton || 'Pr\u00e9venez-moi';
        showMsg(msgEl, strings.errorLabel || 'Une erreur est survenue. Veuillez r\u00e9essayer.', true);
        console.warn('[wishlist-bis] Klaviyo API error:', err);
      });
  }

  function showMsg(el, text, isError) {
    el.textContent = text;
    el.style.display = 'block';
    el.style.color = isError ? '#e92426' : '#5F4F46';
  }

  // ── Card processing ──────────────────────────────────────────────────────

  function processCard(card) {
    if (card.querySelector('.wishlist-bis-button')) return;
    if (!card.querySelector('.st-product-card_group')) return;

    var atcButton = card.querySelector('.st-atc-button');
    if (!atcButton) return;
    var buttonText = atcButton.textContent.trim().toLowerCase();
    var isSoldOut = atcButton.disabled ||
      buttonText.indexOf('out of stock') !== -1 ||
      buttonText.indexOf('rupture de stock') !== -1 ||
      buttonText.indexOf('sold out') !== -1 ||
      buttonText.indexOf('épuisé') !== -1 ||
      (SOLD_OUT_TEXT && buttonText.indexOf(SOLD_OUT_TEXT.toLowerCase()) !== -1);
    if (!isSoldOut) return;

    // Fix: loading overlay may still intercept pointer events
    var loadingOverlay = card.querySelector('.st-product-card_loading');
    if (loadingOverlay) loadingOverlay.style.pointerEvents = 'none';

    var productId = card.dataset.id || '';
    var variantId = card.dataset.variantId || '';
    var titleEl = card.querySelector('.st-product-card_title a');
    var productName = titleEl ? titleEl.textContent.trim() : '';

    var newButton = document.createElement('button');
    newButton.type = 'button';
    newButton.className = 'wishlist-bis-button st-atc-button';
    newButton.id = 'ProductSubmitButton-wishlist-' + productId;
    newButton.textContent = BIS_LABEL;

    newButton.addEventListener('click', function (e) {
      e.stopPropagation();
      openModal(variantId, productName);
    });

    atcButton.replaceWith(newButton);
  }

  function processAllCards() {
    document.querySelectorAll('st-product-card').forEach(processCard);
  }

  function getAffectedCards(mutations) {
    var cards = new Set();
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      for (var j = 0; j < m.addedNodes.length; j++) {
        var node = m.addedNodes[j];
        if (node.nodeType !== 1) continue;
        if (node.tagName.toLowerCase() === 'st-product-card') {
          cards.add(node);
        } else if (node.querySelectorAll) {
          node.querySelectorAll('st-product-card').forEach(function (c) { cards.add(c); });
        }
      }
      var target = m.target;
      while (target && target !== document) {
        if (target.tagName && target.tagName.toLowerCase() === 'st-product-card') {
          cards.add(target);
          break;
        }
        target = target.parentNode;
      }
    }
    return cards;
  }

  var observer = new MutationObserver(function (mutations) {
    getAffectedCards(mutations).forEach(processCard);
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });

  processAllCards();

  // Close on Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });
})();
